// 历史相关
import { sdkIsLogin } from '@utils/business-utils';
import { getuuid } from '@utils/';
import Vue from 'vue';

const isLogin = sdkIsLogin();

// 更新搜索记录_浏览记录
export const addHistory = (info = {}) => {
  if (!isLogin) return;
  const params = {
    visit_type: 0, // 0 搜索记录 1 浏览记录
    ext: {}, // 额外存储信息
    content: '', // 搜索文本
    biz_code: '', // 类型
    session_id: getuuid(32), // 索引
    ...info,
  };
  // if (params.visit_type === 1) {
  //   params.session_id = '';
  // }
  Vue.prototype.$requestPost('/jstore/visitlog/add', params).then(res => {
    if (res.status_code === 0) {
      //
    }
  });
};
